module.exports = __webpack_public_path__ + "img/certificate-IE-7.0+.70ef44f7.jpg";